import React, { useState } from 'react';
import { Alert, Snackbar } from '@mui/material';
import { useLocation } from 'react-router-dom';
import ParentWrapper from '../../../components/ParentWrapper';
import CandidatesTab from './CandidatesTab';
import BranchCandidatesTab from './BranchCandidatesTab';
import BranchManagerAccountsTab from './BranchManagerAccountsTab';
import InterviewsTab from './InterviewsTab';
import CallsTab from './CallsTab';
import BotInterviewsWorkspace from './BotInterviewsWorkspace';
import CandidateDetailPage from './CandidateDetailPage';

export default function BotInterviews() {
  const { pathname } = useLocation();
  const [refreshKey, setRefreshKey] = useState(0);
  const [selectedCandidateId, setSelectedCandidateId] = useState('');
  const [notice, setNotice] = useState({ open: false, message: '', severity: 'info' });

  const onMessage = (message, severity = 'info') => setNotice({ open: true, message, severity });
  const handleRefresh = () => setRefreshKey((key) => key + 1);

  if (pathname === '/user/bot-interviews') {
    return (
      <ParentWrapper sx={{ minHeight: "calc(100vh - 45px)" }}>
        <BotInterviewsWorkspace key={`bot-${refreshKey}`} onMessage={onMessage} onRefresh={handleRefresh} />
        <Snackbar open={notice.open} autoHideDuration={5000} onClose={() => setNotice((current) => ({ ...current, open: false }))}>
          <Alert severity={notice.severity} onClose={() => setNotice((current) => ({ ...current, open: false }))}>
            {notice.message}
          </Alert>
        </Snackbar>
      </ParentWrapper>
    );
  }

  let content = (
    <CandidatesTab
      key={`candidates-${refreshKey}`}
      onMessage={onMessage}
      onComplete={handleRefresh}
      selectedCandidateId={selectedCandidateId}
      setSelectedCandidateId={setSelectedCandidateId}
    />
  );

  if (pathname === '/user/bot-interviews/candidates') {
    content = (
      <CandidatesTab
        key={`candidates-${refreshKey}`}
        onMessage={onMessage}
        onComplete={handleRefresh}
        selectedCandidateId={selectedCandidateId}
        setSelectedCandidateId={setSelectedCandidateId}
      />
    );
  } else if (pathname === '/user/bot-interviews/candidates/new') {
    content = (
      <CandidatesTab
        key={`candidates-new-${refreshKey}`}
        onMessage={onMessage}
        onComplete={handleRefresh}
        selectedCandidateId={selectedCandidateId}
        setSelectedCandidateId={setSelectedCandidateId}
        initialAddOpen
      />
    );
  } else if (pathname.startsWith('/user/bot-interviews/candidates/')) {
    content = <CandidateDetailPage key={`candidate-detail-${refreshKey}`} onMessage={onMessage} />;
  } else if (pathname === '/user/bot-interviews/branch-candidates') {
    content = <BranchCandidatesTab key={`branch-candidates-${refreshKey}`} onMessage={onMessage} onComplete={handleRefresh} />;
  } else if (pathname.startsWith('/user/bot-interviews/branch-candidates/')) {
    content = <CandidateDetailPage key={`branch-candidate-detail-${refreshKey}`} onMessage={onMessage} />;
  } else if (pathname === '/user/bot-interviews/branch-managers') {
    content = <BranchManagerAccountsTab key={`branch-managers-${refreshKey}`} onMessage={onMessage} onComplete={handleRefresh} />;
  } else if (pathname === '/user/bot-interviews/interviews') {
    content = <InterviewsTab key={`interviews-${refreshKey}`} onMessage={onMessage} onRefresh={handleRefresh} />;
  } else if (pathname === '/user/bot-interviews/calls') {
    content = <CallsTab key={`calls-${refreshKey}`} onMessage={onMessage} onRefresh={handleRefresh} />;
  }

  return (
    <ParentWrapper sx={{ minHeight: "calc(100vh - 45px)" }}>
      {content}
      <Snackbar open={notice.open} autoHideDuration={5000} onClose={() => setNotice((current) => ({ ...current, open: false }))}>
        <Alert severity={notice.severity} onClose={() => setNotice((current) => ({ ...current, open: false }))}>
          {notice.message}
        </Alert>
      </Snackbar>
    </ParentWrapper>
  );
}
